export default __webpack_public_path__ + "static/media/mortgage-fx.d362dfea.svg";